import {
  ExpandableSection,
  ExpandableSectionProps,
  Flex,
  FlexAnchor,
  Icon,
  smBumps,
  Typo,
  xsBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { Quote } from '../../../domain'
import { useCoverOptions } from '../../../hooks/covers'
import {
  tCovers,
  tFormats,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { getCoreAssetType } from '../../../state/configuration'
import { useProduct } from '../../product/ProductProvider'
import { useOptionalCoverModal } from './useOptionalCoverModal'

export interface OptionalCoversExpandableProps extends ExpandableSectionProps {
  quote: Quote
  showPremiums?: boolean
}

export const OptionalCoversExpandable: FunctionComponent<
  OptionalCoversExpandableProps
> = ({ quote, showPremiums, header, ...props }) => {
  const { t } = useWriskTranslation()
  const { product } = useProduct()
  const optionalCovers = useCoverOptions(quote, product).filter((it) => it.active)

  const assetType = getCoreAssetType(product)
  const coverModal = useOptionalCoverModal(quote)

  const cells = optionalCovers.map((it) => {
    const premium = showPremiums && (
      <Typo typoSize='sm'>
        {t(tFormats('currency.long'), {
          amount: it.premium,
        })}
      </Typo>
    )
    return (
      <FlexAnchor
        key={`${assetType.code}.${it.coverOption}`}
        width={1}
        px={smBumps}
        py={3}
        onClick={() => coverModal(it)}
        flexDirection='row'
      >
        <Flex>
          <Icon icon='tick' size='small' mr={smBumps} />
          <Typo typoSize='sm'>{t(tCovers(it.coverOption, 'name'))}</Typo>
        </Flex>
        <Flex>
          {premium}
          <Icon size='tiny' icon='info' ml={xsBumps} />
        </Flex>
      </FlexAnchor>
    )
  })

  return cells.length ? (
    <ExpandableSection header={header} {...props}>
      {cells}
    </ExpandableSection>
  ) : null
}
